module.exports = __webpack_public_path__ + "img/1576813218.762341d1.jpg";